import React from "react";
import "../../../styles/main.css";
import PageHeader from "../../../components/reusable/ModuleHeader/PageHeader";
import Breadcrumb from "../../../components/reusable/ModuleHeader/Breadcrumb";


const Page21 = () => {
  return (

    <div style={{ padding: 4 }}>
      <Breadcrumb
        items={[
          { label: "homepage", href: "/HomePage" },
          { label: "stream / overview", href: "/page21" },
        ]}
      />
      <PageHeader
        title="Overview"
        subtitle="Gérez les flux de données et connections du projet"
        className= "title-stream"
      />
      {/* Contenu de la page */}
      
      
    </div>

  );
};

export default Page21;
